import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@webparts/store/types'
import * as typesAccount from '@account/store/types'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import { IEDate, uGetDateFormat } from '@appbase/util';

import api from '@webparts/api'
import { buildStyle } from "@appbase/util/popup-helper"
import IFrameModal from '@appbase/components/modal/IFrameModal.vue'

const tempMails: graph.MailItem[] = [
    {
        id: '',
        subject: '[볼링동호회] 11월 게임 안내',
        from: {
            emailAddress: {
                name: '차은우',
                address: 'ewcha@feelanet.com'
            }
        },
        sentDateTime: new Date(),
        hasAttachments: false,
        webLink: ''
    },
    {
        id: '',
        subject: '[결재완료] 개인비용청구서',
        from: {
            emailAddress: {
                name: '조인성',
                address: 'ischo@feelanet.com'
            }
        },
        sentDateTime: new Date(),
        hasAttachments: false,
        webLink: ''
    }
];


@Component({
    name: 'kbb-maillist-webpart',
    components: { LoadingBar, NoData, WebpartTemplate },
    computed: mapGetters({
        current: typesAccount.CURRENT,
        unreadMails: types.WEBPART_UNREADMAIL_DATA,
        dataMounted: types.WEBPART_COMMONDATA_MOUNTED
    }),

    methods: {
        ...mapActions({
            loadUnreadMails: types.WEBPART_UNREADMAIL_DATA
        })
    }
})
export default class MailListWebpart extends Mixins(WebpartBase) {
    @Prop({ type: Object }) webpart !: webpartv3.Webpart

    loadUnreadMails!: () => Promise<graph.MailResponse>;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    unreadMailList: graph.MailItem[] = [];
    recentMailList: graph.MailItem[] = [];
    showRecentMails: boolean = false;
    workflowList = [];
    noMailBox: boolean = false

    tabMenu = [
        {
            title: '메일',
            value: 'mail'
        },
        {
            title: '결재',
            value: 'workflow'
        }
    ];
    activeTab: string = 'mail';
    workflowMenuId: number = 0;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent
    unreadMails!: graph.MailItem[]
    dataMounted!: boolean

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    get user() {
        return this.current.user
    }

    get company() {
        return this.current.company
    }
    
    get distinctRecentMailList(){
        return this.recentMailList.filter(r=> this.unreadMailList.findIndex(m=>m.id === r.id) === -1).slice(0,5)
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    @Watch('dataMounted')
    onDataMounted(newVal: boolean) {
        this.loading = true;
        let releaseLoading: Promise<void> = Promise.resolve();

        if (this.preview) {
            this.unreadMailList = tempMails;
        } else if (!this.current.user.isMailUser) {
            this.noMailBox = true;
        } else {
            this.unreadMailList = this.unreadMails;
            this.showRecentMails = this.unreadMailList.length < 5;   
            
            if(this.showRecentMails) {
                releaseLoading = api.graph.getRecentMail().then(res => {
                    this.recentMailList = res.items;
                });
            }
        }

        releaseLoading.finally(() => { this.loading = false; }); 
    }
   
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    handleClick(link: string) {
        if (this.preview) return

        const style = buildStyle({
            width: 900,
            height: 660
        });

        window.open(link, '_blank', style);
    }

    async getRecentMails() {    
        this.loading = true;
        let mailResponse = await api.graph.getRecentMail();
        this.recentMailList = mailResponse.items;        
        this.loading = false;
    }

    async getWorkflowList() {
        this.loading = true;
        let endDate = IEDate(new Date());
        let startDate = IEDate(endDate);
        startDate.setFullYear(startDate.getFullYear() - 1);

        this.workflowMenuId = Number(this.getAppConfig('WorkflowMainMenuId'));

        if (this.workflowMenuId != 0) {
            await api.kyobobook.getDocumentBoxItemList({
                menuId: this.workflowMenuId,
                personCode: this.user.personCode,
                deptCode: this.user.deptCode,
                startDate: IEDate(startDate),
                endDate: IEDate(endDate),
                itemsPerPage: 99,
                page: 1,
                searchText: "",
                searchValue: 0,
                applicationId: 0,
            }).then((res) => {
                var dt = Object.create(null);
                if (res) {
                    dt = JSON.parse(res.result);
                    this.workflowList = dt.map((item: any) => {
                        return {
                            ...item
                        };
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            }).catch((err) => {
                this.loading = false;
            })
        } else {
            this.loading = false;
        }
    }

    async tabClicked(val: string) {
        if (this.preview) return;
        this.activeTab = val;

        if (this.activeTab == 'workflow') {
            await this.getWorkflowList();
        }
    }

    async handleClickMore() {
        let routePath = '';

        if (this.activeTab == 'mail') {
            window.open('https://outlook.office.com/mail', '_blank');
        } else {
            routePath = `/workflow/page/documentbox?MENUID=${this.workflowMenuId}&SYSID=1`;
        }

        window.location.href = routePath;
    }

    convertDate(val: Date) {
        return uGetDateFormat('yyyy-MM-DD H:i', IEDate(val))
    }

    openForm(item:any){
        if (this.preview) return
    
        let url = window.location.host;
        let storekey = `s_${new Date().getTime()}`;
    
        if(process.env.NODE_ENV==='production'){
          url =''
          url += '/workflow'
        } 
        url += `/page/form?apmid=${item.ApmId}&appid=${item.ApplicationId}&storekey=${storekey}&pop=1`
    
        if(this.isTeams){
          const modal: appbase.IModalOpenable = this.$refs['modal'] as any
          const options: appbase.TModalInfo<any> = {
            component: IFrameModal,
            props: {title:item.Subject, mStyle:'width: 1024px; height: 600px; padding:0', src: url },
            events: {
              cancel: () => {
                modal.closeModal()
              },
            },
          }
          modal.openModal(options)
        }
        else{
            const style = buildStyle({
                width: 1100,
                height: 1000
            });

            window.open(url,'_blank', style);
        }
        
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //  

    created() {
        this.loading = true;
        if(this.dataMounted) {
            this.onDataMounted(true);
        }
    }
}
